module.exports = __webpack_public_path__ + "media/images/coupon/tel-dbb97fa116e29ec8775d9d45a5c96047.png";